import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ddfb018"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-trigger" }
const _hoisted_2 = ["disabled", "aria-controls", "aria-expanded"]
const _hoisted_3 = { class: "custom-card-related label-text" }
const _hoisted_4 = {
  key: 0,
  class: "icon caret"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "dropdown-content" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown transaction-download-dropdown", {
      'is-active': _ctx.isDropdownOpen,
    }]),
    ref: "dropdown"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass([
          'button',
          'custom-button-modal',
          'has-text-weight-medium',
          'transaction-list-download',
        ]),
        style: _normalizeStyle(_ctx.buttonStyle),
        disabled: _ctx.disabled,
        "aria-haspopup": "true",
        "aria-controls": _ctx.dropdownMenuId,
        "aria-expanded": _ctx.isDropdownOpen,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)), ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.displayLabel), 1),
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
              _createVNode(_component_fa_icon, {
                icon: "fa-angle-down",
                class: "fa-lg"
              })
            ]))
          : _createCommentVNode("", true)
      ], 12, _hoisted_2)
    ]),
    _createElementVNode("div", {
      class: "dropdown-menu",
      id: _ctx.dropdownMenuId,
      role: "menu"
    }, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedOptions, (option) => {
          return (_openBlock(), _createElementBlock("a", {
            key: option.value,
            href: "#",
            class: "dropdown-item",
            onClick: _withModifiers(($event: any) => (_ctx.onSelect(option)), ["prevent"])
          }, _toDisplayString(option.label), 9, _hoisted_7))
        }), 128))
      ])
    ], 8, _hoisted_5)
  ], 2))
}